module.exports = __webpack_public_path__ + "img/selectDown.c66b213d.svg";